import { render, staticRenderFns } from "./PerformanceReportVersionPage.vue?vue&type=template&id=0f37798e&scoped=true"
import script from "./PerformanceReportVersionPage.vue?vue&type=script&lang=js"
export * from "./PerformanceReportVersionPage.vue?vue&type=script&lang=js"
import style0 from "./PerformanceReportVersionPage.vue?vue&type=style&index=0&id=0f37798e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f37798e",
  null
  
)

export default component.exports